module.exports = __webpack_public_path__ + "media/images/store_badges/app_store/app_store_ja-6d665a89cbb2ae2828c30e215c67d31a.png";